module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-14.bef00391.JPG";